var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{attrs:{"showFilter":false,"showSearch":false,"showExportation":false},on:{"addEvent":function($event){return _vm.$router.push({name: 'addNews'})}}},[_vm._v(_vm._s(_vm.$t('auth.news')))]),_c('main-table',{attrs:{"fields":_vm.fields,"baseURL":_vm.VUE_APP_WEBSITE_LINK,"list_url":'admin/news'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }